const generalDict = {
  ARTICLES: "Articoli",
  VIEW_MORE: "Scopri di più",
  SOCIALS: "Socials",
};
export default generalDict;
